import React, { useEffect, useState } from 'react';
import EditOrganization from './EditOrganization';
import ViewBasicInfo from './ViewBasicInfo';
import ViewDetailContractInfo from './ViewDetailContractInfo';
import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';
import LoadingPanel from '@/component/common/LoadingPanel';
import {
    initCorporationContractDetail,
    isShowTabContractDetailByRootOrg
} from './EditOrganizationHandler';
import Utils from '@/common/utils/utils';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { multiPanelAtom, reloadEditContractTabIdAtom } from '@/state/atom/panelAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { userAtom } from '@/state/atom/userAtom';

export default function CorporationContractDetail(props) {
    const initTitleBars = [
        {
            id: Constant.ROOT_CORPORATION.TOOL_BAR.CONTRACT_INFO,
            label: I18n.get('LABEL-TAB-CONTRACT-INFO'),
            isExpand: false
        },
        {
            id: Constant.ROOT_CORPORATION.TOOL_BAR.RESOURCE_USAGE,
            label: I18n.get('LABEL-TAB-RESOURE-USAGE-STATUS'),
            isExpand: false
        },
        {
            id: Constant.ROOT_CORPORATION.TOOL_BAR.OPTION_USAGE,
            label: I18n.get('LABEL-TAB-OPTION-USAGE-STATUS'),
            isExpand: false
        },
        {
            id: Constant.ROOT_CORPORATION.TOOL_BAR.PROVIDE_FUNCTION,
            label: I18n.get('LABEL-TAB-PROVIDE-FUNTION'),
            isExpand: false
        },
        {
            id: Constant.ROOT_CORPORATION.TOOL_BAR.INVIDUAL_BASIC_SETTING,
            label: I18n.get('LABEL-TAB-INVIDUAL-MAX-SETTING'),
            isExpand: false
        }
    ];
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const corporationDetail = useRecoilValue(corporationAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [reloadEditContractTabId, setReloadEditContractTabId] = useRecoilState(
        reloadEditContractTabIdAtom
    );

    const [titleBars, setTitleBars] = useState(initTitleBars);

    const [value, setValue] = useState(Constant.ROOT_CORPORATION.COMPONENT_BASIC_INFO);
    const [isLoading, setIsLoading] = useState(false);
    const [contractDetail, setContractDetail] = useState({});
    const [triggerReload, setTriggerReload] = useState('');
    const [isShowReload, setIsShowReload] = useState(false);
    const userDetail = useRecoilValue(userAtom);


    useEffect(() => {
        setIsLoading(true);
        initCorporationContractDetail(props?.API, props.orgId, userDetail?.affiliationOrganization)
            .then(data => {
                if (!data || Utils.isEmptyObject(data)) return;
                if (
                    data?.corporationData?.active === Constant.CORPORATION_ACTIVE.DELETED
                ) {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
                        panelId: props.panelId,
                        tabId: props.tabId
                    });
                    return;
                }

                if (!Utils.isEmptyArray(data.adminList)) {
                    data.adminList = Utils.sortListByLabelDictionaryASC(data.adminList, 'fullName');
                }
                
                setContractDetail(data);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    }, [props.orgId, triggerReload]);

    useEffect(() => {
        if (!Utils.isEmptyString(corporationDetail.id)) {
            if (corporationDetail.rootFlag !== Constant.ROOT_FLAG.TRUE) {
                let newPanelList = panelList?.filter(
                    panel =>
                        panel.type !== props.panelType &&
                        panel.type !== Constant.PANEL_TYPE.ROOT_LIST_ORG
                );
                setPanelList([...newPanelList]);
            }
        }
    }, [corporationDetail]);

    //trigger reload tab when edit org from list org panel
    useEffect(() => {
        if (reloadEditContractTabId === props.orgId) {
            setTriggerReload(Date.now().toString());
            setReloadEditContractTabId('tabId');
        }
    }, [reloadEditContractTabId]);

    const getViewByTabInfo = () => {
        switch (value) {
            case Constant.ROOT_CORPORATION.COMPONENT_BASIC_INFO:
                return (
                    <ViewBasicInfo
                        {...props}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        triggerReload={triggerReload}
                        setTriggerReload={setTriggerReload}
                        contractDetail={contractDetail}
                        setIsShowReload={setIsShowReload}
                    />
                );
            case Constant.ROOT_CORPORATION.COMPONENT_CONTRACT_DETAILS:
                return (
                    <ViewDetailContractInfo
                        {...props}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        triggerReload={triggerReload}
                        setTriggerReload={setTriggerReload}
                        titleBars={titleBars}
                        setTitleBars={setTitleBars}
                        contractDetail={contractDetail}
                    />
                );
            default:
                return <EditOrganization {...props} setIsShowReload={setIsShowReload} />;
        }
    };

    return (
        <div className="corporation-contract-detail">
            <LoadingPanel isLoading={isLoading} />
            <div className="tabs">
                <div
                    className={`btn-tab ${value ===
                        Constant.ROOT_CORPORATION.COMPONENT_BASIC_INFO && 'btn-tab-active'}`}
                    onClick={() => setValue(Constant.ROOT_CORPORATION.COMPONENT_BASIC_INFO)}
                >
                    {I18n.get('LABEL-TAB-BASIC-INFO')}
                </div>
                {isShowTabContractDetailByRootOrg(contractDetail?.corporationData) && (
                    <div
                        className={`btn-tab ${value ===
                            Constant.ROOT_CORPORATION.COMPONENT_CONTRACT_DETAILS &&
                            'btn-tab-active'}`}
                        onClick={() =>
                            setValue(Constant.ROOT_CORPORATION.COMPONENT_CONTRACT_DETAILS)
                        }
                    >
                        {I18n.get('LABEL-TAB-CONTRACT-INFO')}
                    </div>
                )}
            </div>
            <div className="wrapper-list-tabs">{getViewByTabInfo()}</div>

            <ConfirmDialog
                isOpen={isShowReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}
